module.exports = __webpack_public_path__ + "img/IconName.abf370df.svg";